export default __webpack_public_path__ + "public/media/ms-store.e9bc80f1.png";